import * as authEvents from "../../store/events/auth";
import * as profileActions from "../../store/actions/profile";
import Box from "@mui/material/Box";
import Button from "../Button/Button";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import useInterval from "../../utils/hooks/useInterval";
import { Form, format, generateId } from "@pheaa/channels-component-library";
import { connect, useSelector } from "react-redux";

const IconClock = props => {
	return (
		<SvgIcon viewBox="0 0 40 40" {...props}>
			<g fill="white">
				<path d="M19.75 38.75C30.2434 38.75 38.75 30.2434 38.75 19.75C38.75 9.25659 30.2434 0.75 19.75 0.75C9.25659 0.75 0.75 9.25659 0.75 19.75C0.75 30.2434 9.25659 38.75 19.75 38.75Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M20.75 5.75V21.85L30.75 26.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</g>
		</SvgIcon>
	);
};

const AccountLinkLock = props => {

	const {
		endSession,
		isPendingSessionEnd,
		registration = {},
		setDataProfile
	} = props;

	const { nextAttemptAllowed } = registration;
	const profileData = useSelector(state => state.profile.data);

	const getSecondsRemaining = () => {
		const now = Math.floor(new Date().getTime() / 1000);
		const nextAllowed = Math.ceil(new Date(nextAttemptAllowed).getTime() / 1000);
		return nextAllowed - now;
	};

	const [secondsRemaining, setSecondsRemaining] = React.useState(getSecondsRemaining());

	useInterval(() => {
		setSecondsRemaining(getSecondsRemaining());
	}, 1000);

	const handleSubmit = (e, formData) => {
		// Generate a UID in registration object to force store update, re-rendering parent;
		setDataProfile({ data: { ...profileData, registration: { ...registration, uid: generateId() } } });
	};

	let { value, title } = format.asHourMinSec(Math.max(0, secondsRemaining));

	return (
		<React.Fragment>
			<Typography mb={2.5} paragraph={true}>
				We see you're having trouble linking to your PHEAA account.
				Unfortunately, you will need to wait to try again.
			</Typography>
			<Typography paragraph={true} variant="h2" title={title} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<IconClock sx={{ height: "40px", marginRight: 1.5, width: "40px" }} /> {value}
			</Typography>
			<Form
				id="defaultFormNarrow"
				onSubmit={handleSubmit}
			>
				<Box mt={5.625}>
					<Button
						disabled={secondsRemaining > 0 || isPendingSessionEnd}
						type="submit"
						variant="contained"
					>
						Try Again
					</Button>
					<Box mt={1.75}>
						<Button
							disabled={isPendingSessionEnd}
							onClick={() => { endSession(); }}
							processing={isPendingSessionEnd}
							size="small"
						>
							Sign Out
						</Button>
					</Box>
				</Box>
			</Form>
		</React.Fragment>
	);
};

const mapStateToProps = state => ({
	isPendingSessionEnd: state.auth.isPendingSessionEnd,
	registration: state.profile.data.registration
});

const mapDispatchToProps = dispatch => ({
	endSession: data => dispatch(authEvents.endSession(data)),
	setDataProfile: data => dispatch(profileActions.setData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkLock);